<template>
    <h1>Contact Page</h1>
</template>

<script>
export default {
    name: 'ContactPage',
};
</script>